import { MyInterviewWidgetService } from "@/services/pages/clients/recruitment/my-interview-widget";

export class MyInterviewWidgetAction
{
    constructor()
    {
        this.myInterviewWidgetService = new MyInterviewWidgetService()
    }
    
    async setIntroductionVideo(from, token)
    {
        let introduction_video_key = document.getElementById("myinterview-videoId")?.value
        let params = {introduction_video_from: from, token: token}
        if(introduction_video_key) params.introduction_video_key = introduction_video_key
        let result = await this.myInterviewWidgetService.setInterviewData(params);
        console.log(result)
        // this.setApiError(result.request);
    }

    async setInterviewVideo(from, token)
    {
        let introduction_video_key = document.getElementById("myinterview-videoId")?.value
        let params = {introduction_video_from: from, token: token}
        if(introduction_video_key) params.introduction_video_key = introduction_video_key
        let result = await this.myInterviewWidgetService.setInterviewVideo(params);
        window.location.reload();
    }
}